/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgFluentIconWord = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16 4V1a1.003 1.003 0 0 0-1-1H4a1 1 0 0 0-1 1v3l6.5 1.379z",
        fill: "#41a5ee"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2b7cd3",
        d: "M15.999 4h-13v4L9.5 9.168 15.999 8V4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#185abd",
        d: "M16 8H3v4l6.499 1L16 12V8z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3 12v3a1.003 1.003 0 0 0 1 1h11a1 1 0 0 0 1-1v-3z",
        fill: "#103f91"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 4.003 3 4l.002 10H9a2 2 0 0 0 2-2V5.002a1 1 0 0 0-1-1z",
        opacity: 0.5
    }), /*#__PURE__*/ React.createElement("rect", {
        y: 3,
        width: 10,
        height: 10,
        rx: 1,
        fill: "#185abd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.352 9.54q.026.213.034.372h.02q.011-.15.045-.364t.065-.36L4.429 5H5.61l.945 4.126a6.335 6.335 0 0 1 .118.778h.016a6.293 6.293 0 0 1 .098-.753L7.543 5h1.075l-1.323 6H6.04l-.901-3.975q-.04-.171-.089-.448t-.06-.401h-.017q-.015.146-.06.435t-.073.427L3.992 11H2.716L1.382 5h1.094L3.3 9.197q.028.13.053.343z",
        fill: "#fff"
    }));
export default SvgFluentIconWord;
